import { useSelector } from "react-redux";
import { filterByAuthor, filterByCategory, searchPost } from "./../lib/filterPosts";
import Blog from "./Blog";

const BlogContainer = () => {
  const { titleFilter, category, author } = useSelector((state) => state.filters);
  const posts = useSelector((state) => state.blogPosts);
  return (
    <div className='mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none'>
      {posts
        .filter((post) => searchPost(post, titleFilter))
        .filter((post) => filterByCategory(post, category))
        .filter((post) => filterByAuthor(post, author))

        .map((post) => (
          <Blog key={post.id} blogDetails={post} />
        ))}
    </div>
  );
};

export default BlogContainer;
